import React from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import MDBox from "../../../materialDashboard/components/MDBox";
import {useCreateIncident, useCreateIncidentAttachment} from "../query";
import IncidentForm from "../IncidentForm";
import {useFeedbackTools} from "../../../components/FeedbackTools";


const IncidentCreate = () => {
    const {t} = useTranslation(['incidents']);
    const navigate = useNavigate();
    const createIncident = useCreateIncident({disableNotification: true});
    const createIncidentAttachment = useCreateIncidentAttachment({disableNotification: true});
    const {showSuccessNotification, showErrorNotification}  = useFeedbackTools();

    const handleSubmit = async (data) => {
        const {attachments, ...rest} = data;
        const incident = await createIncident.mutateAsync(rest);
        showSuccessNotification(t('query.createSuccess'));
        if (attachments) {
            try {
                await Promise.all(attachments.map((attachment) => createIncidentAttachment.mutateAsync({
                    id: incident.id,
                    data: attachment
                })));
            }
            catch (e) {
                console.error(e);
                showErrorNotification(t('query.createAttachmentError'));
            }
        }
        await navigate('/incidents');
    }

    return <MDBox sx={{mx: 2}}>
        <IncidentForm title={t('incidentCreate.title')}
                      onSubmit={handleSubmit}/>
    </MDBox>
}

export default IncidentCreate;